import React from 'react';

const YogaAndPoolSection = () => {
  const wrapperStyle = {
    backgroundImage: "url('/bbkandy/images/hotelbg/bbkandy.webp')",
    backgroundSize: "cover",
    padding: "60px 20px"
  };

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "60px"
  };

  const sectionStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "40px",
    flexWrap: "wrap"
  };

  const reverseStyle = {
    ...sectionStyle,
    flexDirection: "row-reverse"
  };

  const textBlockStyle = {
    backgroundColor: "#eeb85e",
    color: "#3a4a26",
    padding: "30px 25px",
    borderRadius: "30px",
    maxWidth: "400px",
    boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)"
  };

  const titleStyle = {
    fontSize: "26px",
    fontWeight: "bold",
    marginBottom: "12px",
    color: "#414f28"
  };

  const imageStyle = {
    maxWidth: "716px",
    maxHeight: "1300px",
    width: "100%",
    height: "auto",
    borderRadius: "20px"
  };

  const animateLeft = {
    animation: "fadeInLeft 1s ease-in-out"
  };

  const animateRight = {
    animation: "fadeInRight 1s ease-in-out"
  };

  return (
    <section style={wrapperStyle}>
      <div style={containerStyle}>
        {/* Yoga Section */}
        <div style={sectionStyle}>
          <img
            style={imageStyle}
            src="/bbkandy/images/home/yoga.webp"
            alt="Yoga Space"
          />
          <div style={{...textBlockStyle, ...animateRight}}>
            <h3 style={{
              fontSize: "30px",
              fontWeight: 500,
              letterSpacing: "0px",
              lineHeight: 1.6,
              textTransform: "none",
              ...titleStyle
            }}>Yoga Space</h3>
            <p style={{
              fontSize: "18px",
              fontWeight: 400,
              textTransform: "none",
            }}>
              Unwind and rejuvenate in our serene yoga space, harmonizing mind, body, and spirit amid tranquility.
            </p>
          </div>
        </div>

        {/* Pool Section (reversed layout on desktop) */}
        <div style={reverseStyle}>
          <img
            style={imageStyle}
            src="/bbkandy/images/pool/1-1.webp"
            alt="Pool"
          />
          <div style={{...textBlockStyle, ...animateLeft}}>
            <h3 style={{
              fontSize: "30px",
              fontWeight: 500,
              letterSpacing: "0px",
              lineHeight: 1.6,
              textTransform: "none",
              ...titleStyle
            }}>Outdoor showers & Pool</h3>
            <p style={{
              fontSize: "18px",
              fontWeight: 400,
              textTransform: "none",
            }}>
              Experience the tropics like never before; bathe in our outdoor shower and watch the sunsets glide by the pool side.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default YogaAndPoolSection;